import { render, staticRenderFns } from "./ChartjsDoughnutChart4.vue?vue&type=template&id=6a1f7594&"
import script from "./ChartjsDoughnutChart4.vue?vue&type=script&lang=js&"
export * from "./ChartjsDoughnutChart4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports